import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPagerduty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M17 3c-1.6-.8-2.7-1-5.2-1H6v12.1h5.8c2.3 0 4-.1 5.5-1.1 1.6-1.1 2.6-3 2.5-5 .1-2.1-1-4-2.8-5m-4.6 8.6H8.9v-7h3.3c3 0 4.5 1 4.5 3.4.1 2.6-1.8 3.6-4.3 3.6M6 22h2.9v-5.3H6z" />
  </svg>
);
export default SvgPagerduty;
